import { useCallback } from "react";
import { usePersonPath } from "../routing/usePersonPath.ts";
import { usePersonProfileTab } from "./PersonProfileTabProvider.tsx";

export function usePersonProfilePath() {
    const personPath = usePersonPath();
    const tab = usePersonProfileTab();

    return useCallback((personId: string) => personPath(personId, tab === "overview" ? undefined : tab), [personPath, tab]);
}
